export const GET_CITIES = 'GET_CITIES';
export const GET_CITY = 'GET_CITY';
export const GET_UNIVERSITIES = 'GET_UNIVERSITIES';
export const GET_UNIVERSITY = 'GET_UNIVERSITY';
